import React from "react";
import NextImage from "next/image";

import { Button, DesktopContainer, MobileContainer } from "@/components/Atoms";

import { BenefitsSectionDataI } from "../../shyftPassMaps";

const BenefitsSection = ({
  ctaTitle,
  hideMobileBanner,
}: BenefitsSectionDataI | any) => (
  <div className="container">
    <div className="shyft-pass-benefits-wrapper" id="shyft-pass-how-it-works">
      <div className="shyft-pass-benefits">
        <div className="heading">Shyft Pass gives you access to</div>
        <div className="content">
          <div className="detail">
            <div className="title">Different workouts every weekend</div>
            <div className="description">
              Weekend workouts are held at our partner venues. Check the
              schedule on the Shyft app, choose one workout per weekend, book
              and you&#39;re set!
            </div>
          </div>
          <div className="detail">
            <div className="title">
              Wellness focussed community
            </div>
            <div className="description">
              Workout & engage with a like-minded community. Make friends out of
              acquaintances at our community mixers.
            </div>
          </div>
          <div className="detail">
            <div className="title">
              Latest wellness products
              <div className="description">
                Members get a carefully curated hamper of wellness products from
                our partner brands, with expert information on how they benefit
                your health.
              </div>
            </div>
          </div>
          <div className="cta-section mobile-cta">
            <Button
              variant="primary1"
              onClick={() => {
                document
                  ?.getElementById("shyft-pass-register-section")
                  ?.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                  });
              }}
            >
              {ctaTitle}
            </Button>
          </div>
        </div>
      </div>
      <DesktopContainer className="benefits-image-container">
        <div className="benefits-image-wrapper">
          <NextImage
            className="benefits-image"
            alt="shyft-pass-benefits"
            fill={true}
            priority
            src="https://d1mxd7n691o8sz.cloudfront.net/static/uploads/shyftpass-benefits-desktop.png"
          />
        </div>
      </DesktopContainer>
    </div>
    {!hideMobileBanner && (
      <MobileContainer className="benefits-image-container">
        <div className="benefits-image-wrapper">
          <NextImage
            className="benefits-image"
            alt="shyft-pass-benefits"
            fill={true}
            priority
            src="https://d1mxd7n691o8sz.cloudfront.net/static/uploads/shyft-pass-benefits-image.png"
          />
        </div>
      </MobileContainer>
    )}
  </div>
);

export default BenefitsSection;
